import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { VonMessageService } from '@von-development-studio/primeng-message-service';
import { tap } from 'rxjs/operators';
import { adminCatalogActions } from 'src/app/store/admin/catalog/admin-catalog.action';
import { adminLocationActions } from 'src/app/store/admin/location/admin-location.action';
import { adminUserActions } from 'src/app/store/admin/user/admin-user.action';
import { commonCieActions } from 'src/app/store/common/cie/cie.action';
import { commonDoctorActions } from 'src/app/store/common/doctor/doctor.action';
import { commonPatientActions } from 'src/app/store/common/patient/patient.action';
import { commonPersonActions } from 'src/app/store/common/person/person.action';
import { commonTurnActions } from 'src/app/store/common/turn/turn.action';
import { generalConsultActions } from 'src/app/store/general/general.action';
import { historyActions } from 'src/app/store/history/history.action';
import { screenActions } from 'src/app/store/screen/screen-store.action';
import { environment } from 'src/environments/environment';
import { BaseService } from '../core/base/base.service';
import { RestService } from '../core/service/rest.service';
import { SecurityLoginModel } from '../model/security/security-login';

@Injectable({
  providedIn: 'root',
})
export class LoginService extends BaseService {
  constructor(
    override store: Store<any>,
    protected rest: RestService,
    protected messageService: VonMessageService,
    private route: Router
  ) {
    super();
  }

  init = () => {
    if (this.route.url.indexOf('salir') >= 0) {
      this.rest
        .delete({ url: `${environment.endpoints.auth}/logout` })
        .pipe(
          tap(() => {
            this.store.dispatch(screenActions.setAllDefaultAction(true));
            this.store.dispatch(adminCatalogActions.setAllDefaultAction(true));
            this.store.dispatch(adminLocationActions.setAllDefaultAction(true));
            this.store.dispatch(adminUserActions.setAllDefaultAction(true));
            this.store.dispatch(commonCieActions.setAllDefaultAction(true));
            this.store.dispatch(commonDoctorActions.setAllDefaultAction(true));
            this.store.dispatch(commonPatientActions.setAllDefaultAction(true));
            this.store.dispatch(commonPersonActions.setAllDefaultAction(true));
            this.store.dispatch(commonTurnActions.setAllDefaultAction(true));
            this.store.dispatch(
              generalConsultActions.setAllDefaultAction(true)
            );
            this.store.dispatch(historyActions.setAllDefaultAction(true));
          })
        )
        .subscribe();
    }
  };

  login = ({ username, password }: SecurityLoginModel) =>
    this.rest
      .authenticate(`${environment.endpoints.auth}/login`, username!, password!)
      .pipe(
        tap({
          next: () => this.route.navigate(['/']),
          error: (error) => this.messageService.addError(error.message),
        })
      );
}
